import Button from '../../ui/primitives/Button'
import Card from '../../ui/primitives/Card'
import styles from '../../ui/onboarding/DownloadApp.module.css'

export interface DownloadAppViewProps {
  onContinueWithWeb: () => void
}

export default function DownloadAppView({ onContinueWithWeb }: DownloadAppViewProps) {
  return (
    <div className={styles.wrap}>
      <Card className={styles.card}>
        <h1 className={styles.title}>Get the app!</h1>
        <p className={styles.description}>
          It&apos;s just better on your phone. You can log your activities, see the map and team
          progress, and more!
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.storeBadge} onClick={() => window.open(process.env.REACT_APP_IOS_URL)}>
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
            />
          </button>
          <button
            type="button"
            className={styles.storeBadge}
            onClick={() => window.open(process.env.REACT_APP_ANDROID_URL)}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
            />
          </button>
          <Button variant="ghost" onClick={onContinueWithWeb}>
            Continue with web
          </Button>
        </div>
      </Card>
    </div>
  )
}
